import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { isLoggedIn, getToken } from '../utils/tokenUtils';
import styles from './BoardDetailPage.module.css';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

function BoardDetailPage() {
    const { boardId } = useParams();
    const [board, setBoard] = useState(null);
    const [commentInput, setCommentInput] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        loadBoard();
    }, [boardId]);

    const loadBoard = async () => {
        try {
            const res = await axios.get(`${API_URL}/api/boards/${boardId}`);
            setBoard(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const submitComment = async () => {
        if (!commentInput.trim()) return;
        try {
            await axios.post(`${API_URL}/api/boards/${boardId}/comments`,
                { content: commentInput },
                { headers: { Authorization: `Bearer ${getToken()}` } }
            );
            setCommentInput('');
            loadBoard();
        } catch (err) {
            console.error(err);
        }
    };

    const deleteComment = async (commentId) => {
        try {
            await axios.delete(`${API_URL}/api/boards/comments/${commentId}`,
                { headers: { Authorization: `Bearer ${getToken()}` } }
            );
            loadBoard();
        } catch (err) {
            console.error(err);
        }
    };

    const deleteBoard = async () => {
        if (!window.confirm('삭제하시겠습니까?')) return;
        try {
            await axios.delete(`${API_URL}/api/boards/${boardId}`,
                { headers: { Authorization: `Bearer ${getToken()}` } }
            );
            navigate('/boards');
        } catch (err) {
            console.error(err);
        }
    };

    if (!board) return <div className={styles.loading}>로딩 중.</div>;

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <span className={styles.category}>
                    {board.category === 'NOTICE' ? '공지' : board.category === 'EVENT' ? '이벤트' : '자유'}
                </span>
                <h2 className={styles.title}>{board.title}</h2>
                <div className={styles.meta}>
                    <span>{board.userName}</span>
                    <span>{new Date(board.createdAt).toLocaleDateString()}</span>
                    <span>조회 {board.viewCount}</span>
                </div>
            </div>

            {board.imageUrl && (
                <img src={`${API_URL}${board.imageUrl}`}
                    alt="첨부이미지" className={styles.image} />
            )}

            <div className={styles.content}
                dangerouslySetInnerHTML={{ __html: board.content }} />

            <div className={styles.actions}>
                <button onClick={() => navigate('/boards')} className={styles.backBtn}>목록</button>
                {isLoggedIn() && (
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <button onClick={() => navigate(`/boards/edit/${boardId}`)} className={styles.editBtn}>수정</button>
                        <button onClick={deleteBoard} className={styles.deleteBtn}>삭제</button>
                    </div>
                )}
            </div>

            <div className={styles.comments}>
                <h3 className={styles.commentTitle}>댓글 {board.comments?.length || 0}</h3>
                {board.comments?.map(c => (
                    <div key={c.commentId} className={styles.comment}>
                        <div className={styles.commentMeta}>
                            <span className={styles.commentUser}>{c.userName}</span>
                            <span className={styles.commentDate}>
                                {new Date(c.createdAt).toLocaleDateString()}
                            </span>
                        </div>
                        <p className={styles.commentContent}>{c.content}</p>
                        {isLoggedIn() && (
                            <button onClick={() => deleteComment(c.commentId)}
                                className={styles.commentDeleteBtn}>삭제</button>
                        )}
                    </div>
                ))}

                {isLoggedIn() && (
                    <div className={styles.commentInput}>
                        <textarea value={commentInput} onChange={e => setCommentInput(e.target.value)}
                            placeholder="댓글을 입력해 주세요." className={styles.textarea} rows={3} />
                        <button onClick={submitComment} className={styles.submitBtn}>등록</button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default BoardDetailPage;